import { INVISIBLES } from '@workspace/constants/common.constant';
import type { ApplicationAlignment, ApplicationItemCount } from './application.types';

type ApplicationImageDimensions = {
  desktop: { width: number; height: number };
  mobile: { width: number; height: number };
};

const APPLICATION_IMAGE_DIMENSIONS: Record<ApplicationItemCount, ApplicationImageDimensions> = {
  two: {
    desktop: { width: 588, height: 331 },
    mobile: { width: 288, height: 162 },
  },
  three: {
    desktop: { width: 386, height: 514 },
    mobile: { width: 288, height: 384 },
  },
  four: {
    desktop: { width: 285, height: 285 },
    mobile: { width: 288, height: 288 },
  },
};

const HEADING_JUSTIFY_CLASS: Record<ApplicationAlignment, string> = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};

export const LEGACY_APPLICATION_IMAGE_DIMENSIONS: ApplicationImageDimensions = {
  desktop: { width: 384, height: 290 },
  mobile: { width: 384, height: 290 },
};

export const getHeadingAlignment = (rawAlign: string | undefined): ApplicationAlignment => {
  const normalizedAlign = (rawAlign || 'left').toString().replace(INVISIBLES, '').trim().toLowerCase();

  if (normalizedAlign === 'center' || normalizedAlign === 'right') return normalizedAlign;
  return 'left';
};

export const getHeadingAlignClass = (rawAlign: string | undefined) =>
  HEADING_JUSTIFY_CLASS[getHeadingAlignment(rawAlign)];

export const getApplicationItemCount = (length: number): ApplicationItemCount => {
  if (length <= 2) return 'two';
  if (length === 3) return 'three';
  return 'four';
};

export const getApplicationImageDimensions = (itemCount: ApplicationItemCount = 'three') =>
  APPLICATION_IMAGE_DIMENSIONS[itemCount];
